import { useNavigate } from "react-router";
import TableColumn from "./columns";
import FilterMenu from "./filter-menu";
import { useEffect, useState } from "react";
import SummaryByStatus from "../../../components/summary-status/SummaryByStatus";
import API from "../../../services/api-request";
import { Button, message, Modal, Table } from "antd";
import { useSearchParams } from "react-router-dom";
import "../../../assets/css/style-table.css";
import inboundPrint from "../../../components/print/inbound";
import { usePermissions } from "../../../utils/permissionUtil";

const Inbound = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const { hasCreatePermission, hasUpdatePermission } = usePermissions();

  const queryParams = Object.fromEntries([...searchParams]);
  const pagination = {
    current: parseInt(searchParams.get("page")) || 1,
    pageSize: parseInt(searchParams.get("limit")) || 10,
    total: totalData,
    onChange: (page, limit) => {
      pagination.current = page;
      pagination.pageSize = limit;
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("page", page);
      newSearchParams.set("limit", limit);
      setSearchParams(newSearchParams);
    },
  };

  const getInbound = async (query) => {
    setData([]);
    const queryString = new URLSearchParams(query).toString();
    // Add default page and limit
    if (!searchParams.has("limit")) {
      searchParams.set("limit", 10);
    }
    if (!searchParams.has("page")) {
      searchParams.set("page", 1);
    }
    setSearchParams(searchParams);

    setLoading(true);
    API.Post(`transaction/inbound/list${query ? "?" + queryString : ""}`)
      .then((res) => {
        console.log(res);
        const page = query.page ? parseInt(query.page) - 1 : 0;
        const limit = query.limit ? parseInt(query.limit) : 10;

        setTotalData(res?.data?.data?.totalItems);

        const formatSelect = res?.data?.data?.data?.map((item, index) => {
          return {
            ...item,
            no: page * limit + index + 1,
          };
        });
        console.log("formatSelect", formatSelect);
        setData(formatSelect);
      })
      .catch((err) => {
        setData([]);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDeleteDraft = async (id) => {
    setLoading(true);

    try {
      const res = await API.Delete(`transaction/inbound/detail/${id}`);
      message.success("Draft deleted successfully!");
    } catch (err) {
      err?.response?.data?.error
        ? message.error(`${err?.response?.data?.error}`)
        : message.error("Failed to delete draft!");
    } finally {
      setLoading(false);
      setDeleteModal(false);
      setSelectedData({});
      getInbound(queryParams);
    }
  };

  useEffect(() => {
    getSummary();
    if (queryParams) {
      getInbound(queryParams);
    }
  }, [searchParams]);

  const handleNavigate = (data) => {
    navigate(`/inbound/detail/${data.id}`);
  };

  const handleEdit = (data) => {
    navigate(`/inbound/add`, { state: { data: data } });
  };

  const handleStart = (data) => {
    navigate(`/inbound/start/${data.id}`);
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  const getSummary = async () => {
    try {
      const res = await API.Get(`transaction/inbound/summary`);
      console.log(res.data);
      setSummary(res?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrint = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    printWindow.document.open();
    printWindow.document.write(inboundPrint(data));
    setTimeout(function () {
      printWindow.document.close();
    }, 2000);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print({ showPrintDialog: true });

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  return (
    <>
      <SummaryByStatus
        waiting_inbound={summary?.pending}
        waiting_outbound={null}
        approve={summary?.approve}
        done={summary?.done}
        reject={summary?.reject}
        total={summary?.total}
      />
      <br />
      <FilterMenu />

      <Table
        style={{ maxWidth: "100%", overflow: "auto" }}
        rowClassName={rowClassName}
        columns={TableColumn(
          handleNavigate,
          handleStart,
          handlePrint,
          handleEdit,
          setSelectedData,
          setDeleteModal,
          hasCreatePermission,
          hasUpdatePermission
        )}
        dataSource={data}
        rowKey={(dataSource) => dataSource.id}
        pagination={pagination}
        loading={loading}
        scroll={{ x: "max-content" }}
      />

      <Modal
        title="Delete Draft"
        open={deleteModal}
        onCancel={() => setDeleteModal(false)}
        footer={null}
        onOk={() => handleDeleteDraft(selectedData.id)}
      >
        <p>Are you sure want to delete this draft?</p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <Button onClick={() => setDeleteModal(false)}>Cancel</Button>
          <Button
            type="primary"
            style={{ backgroundColor: "#d32029" }}
            onClick={() => handleDeleteDraft(selectedData.id)}
            loading={loading}
          >
            Yes
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Inbound;
